import { render, staticRenderFns } from "./modify-list.vue?vue&type=template&id=8288b7e0"
import script from "./modify-list.vue?vue&type=script&lang=js"
export * from "./modify-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports